<template>
	<div class="rule_wrap">
		<div class="rule_body">
			<div class="rule_close" @click="close">
				<svg
					t="1643023037965"
					class="icon"
					viewBox="0 0 1024 1024"
					version="1.1"
					xmlns="http://www.w3.org/2000/svg"
					p-id="2048"
					width="18"
					height="18"
				>
					<path
						d="M548.992 503.744L885.44 167.328a31.968 31.968 0 1 0-45.248-45.248L503.744 458.496 167.328 122.08a31.968 31.968 0 1 0-45.248 45.248l336.416 336.416L122.08 840.16a31.968 31.968 0 1 0 45.248 45.248l336.416-336.416L840.16 885.44a31.968 31.968 0 1 0 45.248-45.248L548.992 503.744z"
						p-id="2049"
						fill="#F2B436"
					></path>
				</svg>
			</div>
			<div class="rule_body_wrap">
				<div class="rule_title">小宝驿站规则</div>
				<div class="rule_title_hr"></div>
				<div class="rule_desc">
					小宝驿站会租用您设备的闲置空间开设缓存资源驿站，缓存资源可提供视频、下载等网络加速服务，不仅可以为您带来更快的观影和下载体验，也可以为其他用户提供有偿的加速服务，当您的小宝驿站为其他用户提供加速服务时，驿站总部将会根据您的收发缓存情况进行对应的积分奖励，积分可以兑换各类VIP会员卡或话费充值。
				</div>
				<div class="rule_desc2">奖励参考：1000积分≈1元</div>
				<div class="rule_desc2">
					* 开启小宝驿站不会影响您浏览网页、观看视频或网购等上网体验。
				</div>
				<div class="rule_desc_hr" v-if="false"></div>
				<div class="rule_example_title" v-if="false">
					小宝驿站奖励参考：
				</div>
				<div class="rule_example_items" v-if="false">
					<div class="rule_example_item">
						<div class="item_top">上行带宽&lt;=20M</div>
						<div class="item_middle">理论可获得最大积分</div>
						<div class="item_bottom">0-20000/月</div>
					</div>
					<div class="rule_example_item">
						<div class="item_top">上行带宽&lt;=50M</div>
						<div class="item_middle">理论可获得最大积分</div>
						<div class="item_bottom">0-50000/月</div>
					</div>
				</div>
				<div class="rule_example_desc">
					*
					积分奖励与驿站网速、驿站空间、驿站每日营业时长有关，具体获取积分数量以实际发放积分为准。
				</div>
				<div class="rule_example_desc">
					*
					驿站开业的48小时为资源部署期，若保持驿站稳定经营，则会获得更多奖励。
				</div>
				<div class="rule_example_desc" v-if="false">
					* 以上数据为理论数据，不代表对积分奖励的承诺。
				</div>
				<div class="rule_example_help">
					若驿站无积分或积分较低时，请查阅<span
						class="help"
						@click="
							openUrl('https://yc.ionewu.com/jdb_help/nat.html')
						"
						>《路由优化指引》</span
					>
				</div>
				<div class="rule_desc_hr"></div>
				<div class="rule_btn" @click="close">确 定</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	methods: {
		close: function () {
			this.$emit("close");
		},
		openUrl: function (url) {
			let _that = this;
			_that.$common.bridge(_that.$store.state.client).openBrowser(url);
		},
	},
};
</script>

<style lang="less" scoped>
.rule_wrap {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	z-index: 9;
	background-color: rgba(0, 0, 0, 0.3);
	.rule_body {
		width: 700px;
		height: 460px;
		left: 50%;
		top: 50%;
		margin-left: -350px;
		margin-top: -230px;
		background-color: #20293b;
		position: absolute;
		border-radius: 6px;
		overflow-y: scroll;
		-ms-overflow-style: none;
		scrollbar-width: none;
		.rule_close {
			position: absolute;
			right: 10px;
			top: 10px;
		}
		.rule_close:hover {
			cursor: pointer;
			opacity: 0.9;
		}
		.rule_body_wrap {
			padding-top: 1px;
			padding-bottom: 1px;
			background-image: url(../assets/speedShare/jf_rule_bg.png);
			background-repeat: no-repeat;
			background-size: 100% 100%;
		}
		.rule_title {
			text-align: center;
			color: #f2b436;
			font-size: 20px;
			margin-top: 30px;
			font-weight: bolder;
		}
		.rule_title_hr {
			height: 20px;
			width: 680px;
			background-image: url(../assets/speedShare/jf_rule_title_hr.svg);
			background-size: 100% 100%;
			margin: 0 auto;
			margin-top: 10px;
		}
		.rule_desc {
			width: 650px;
			color: #bb9444;
			font-weight: bolder;
			font-size: 14px;
			margin: 0 auto;
			margin-top: 30px;
			margin-bottom: 20px;
			line-height: 22px;
		}
		.rule_desc2 {
			width: 650px;
			color: #bb9444;
			font-size: 14px;
			margin: 0 auto;
			margin-bottom: 5px;
			line-height: 22px;
		}
		.rule_desc_hr {
			height: 1px;
			width: 670px;
			margin: 0 auto;
			margin-top: 20px;
			background-color: #bb9444;
		}
		.rule_example_title {
			color: #bb9444;
			font-size: 16px;
			font-weight: bolder;
			margin-left: 40px;
			margin-top: 20px;
			background-image: url(../assets/speedShare/jf_rule_title_icon.svg);
			background-size: 7px 7px;
			background-position: left 6px;
			padding-left: 10px;
			background-repeat: no-repeat;
		}
		.rule_example_items {
			text-align: center;
			margin-top: 20px;
			margin-bottom: 35px;
			.rule_example_item {
				width: 190px;
				height: 140px;
				background-image: url(../assets/speedShare/jf_rule_item_bg.svg);
				background-size: 100% 100%;
				background-position: center center;
				background-repeat: no-repeat;
				display: inline-block;
				vertical-align: top;
				margin: 0 18px;
				.item_top {
					color: #fceebb;
					line-height: 27px;
					margin-top: 20px;
					font-weight: bolder;
					font-size: 14px;
				}
				.item_middle {
					font-size: 12px;
					color: #bb9444;
					line-height: 24px;
					margin-top: 22px;
				}
				.item_bottom {
					color: #fff6d6;
					font-size: 20px;
					margin-top: 5px;
					font-weight: bolder;
				}
			}
		}
		.rule_example_desc {
			width: 650px;
			margin: 0 auto;
			color: #bb9444;
			line-height: 28px;
			font-size: 14px;
		}
		.rule_example_desc2 {
			width: 650px;
			margin: 0 auto;
			color: #bb9444;
			line-height: 28px;
			font-size: 14px;
			margin-bottom: 5px;
		}
		.rule_example_help {
			width: 650px;
			margin: 0 auto;
			color: #bb9444;
			line-height: 28px;
			font-size: 14px;
			margin-top: 20px;
			font-weight: bolder;
			.help:hover {
				text-decoration: underline;
				cursor: pointer;
				opacity: 0.9;
			}
		}
		.rule_btn {
			width: 170px;
			height: 40px;
			line-height: 40px;
			font-weight: bolder;
			font-size: 18px;
			color: #ffffff;
			margin: 30px auto;
			background-color: #fabf4a;
			background-image: linear-gradient(to right, #fabf4a, #e2a52b);
			border-radius: 20px;
			text-align: center;
		}
		.rule_btn:hover {
			cursor: pointer;
			opacity: 0.9;
		}
	}
	.rule_body::-webkit-scrollbar {
		display: none;
	}
}
</style>